export const JWT_TEMPLATE = 'Portal';
